module.exports = {

    props: {
        project: {
            type: Object,
            required: true,
        },
        signaturesFor: {
            type: Array,
            required: true,
        }
    },

    data() {
        return {
            canvas: null,
            signatures: {
                employer: null,
                technician: null,
                author: null
            },
            signaturePad: null,
            form: new Form({
                data: null,
                types: null,
            }),
        }
    },

    created() {
        for (key in this.signaturesFor) {
            this.signatures[this.signaturesFor[key]] = this.signaturesFor[key] ? false : null
        }
    },

    mounted() {
        this.canvas =  document.getElementById("signature-pad");
        this.signaturePad = new SignaturePad(this.canvas);
        window.addEventListener("resize", this.resizeCanvas);
        this.resizeCanvas();
    },

    methods: {

        clear() {
            this.signaturePad.clear();
        },

        prepareData() {
            this.form.data = this.signaturePad.toDataURL();
            this.form.types = Object.keys(_.pickBy(this.signatures))
        },

        resizeCanvas() {
            var ratio = Math.max(window.devicePixelRatio || 1, 1);
            this.canvas.width = this.canvas.offsetWidth * ratio;
            this.canvas.height = this.canvas.offsetHeight * ratio;
            this.canvas.getContext("2d").scale(ratio, ratio);
        },
    },

    computed: {

        withEmployer() {
            return this.signatures.employer !== null;
        },

        withTechnician() {
            return this.signatures.technician !== null;
        },

        withAuthor() {
            return this.signatures.author !== null;
        },

        isSignaturePadEmpty() {
            return this.signaturePad && this.signaturePad.isEmpty();
        },

        missingCheckboxes() {
            return _.filter(this.signatures, checked => checked !== null).includes(false)
        }
    }
}
